import { BadgeColor } from '@billy/design-system'

import { InvoiceStatus } from '../enums/invoiceStatus'

export const invoiceStatusToBadgeColor: Record<InvoiceStatus, BadgeColor> = {
  [InvoiceStatus.All]: 'neutral',
  [InvoiceStatus.Credited]: 'success',
  [InvoiceStatus.Deleted]: 'neutral',
  [InvoiceStatus.Draft]: 'accent',
  [InvoiceStatus.Open]: 'neutral',
  [InvoiceStatus.Overdue]: 'danger',
  [InvoiceStatus.Paid]: 'success',
  [InvoiceStatus.PartiallyCredited]: 'warning',
  // the badge colors for the invoice statuses below
  // should be revised while working on the Invoices List revamp
  [InvoiceStatus.Reminded]: 'neutral',
  [InvoiceStatus.Sent]: 'neutral',
  [InvoiceStatus.Unpaid]: 'warning',
  [InvoiceStatus.Unsent]: 'neutral',
}
